import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-service',
  templateUrl: './terms-service.component.html',
  styleUrls: ['./terms-service.component.scss'],
})
export class TermsServiceComponent implements OnInit {
  // Add this method to your Angular component class

  ngOnInit(): void {
    // Check if there's a section to scroll to from the URL fragment
    setTimeout(() => {
      const fragment = window.location.hash.replace('#', '');
      if (fragment) {
        this.scrollToSection(fragment);
      }
    }, 300);
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      // Scroll to the element with some offset for the sticky header
      const yOffset = -80; // Adjust based on your header height
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });

      // Expand the accordion if it's closed
      this.expandAccordion(element);
    }
  }
  expandAccordion(element: HTMLElement): void {
    // Get the parent accordion item
    const accordionItem = element.closest('.border-b') || element;

    // Get the header and content
    const header = accordionItem.querySelector(
      '.flex.justify-between'
    ) as HTMLElement;
    const content = header?.nextElementSibling as HTMLElement;

    if (header && content) {
      // First close all accordions
      const allContents = document.querySelectorAll('.max-h-0');
      allContents.forEach((item) => {
        (item as HTMLElement).classList.remove('!max-h-96');
      });

      const allHeaders = document.querySelectorAll('.flex.justify-between');
      allHeaders.forEach((item) => {
        const span = item.querySelector('span');
        if (span) span.textContent = '+';
      });

      // Then open this accordion
      content.classList.add('!max-h-96');
      const span = header.querySelector('span');
      if (span) span.textContent = '−';
    }
  }
  toggleAccordion(event: Event): void {
    // Get the clicked header
    const header = event.currentTarget as HTMLElement;

    // Get the content div that follows
    const content = header.nextElementSibling as HTMLElement;

    // Toggle the active state
    const isActive = content.classList.contains('!max-h-96');

    // First close all accordions
    const allContents = document.querySelectorAll('.accordion-content');
    allContents.forEach((item) => {
      (item as HTMLElement).classList.remove('!max-h-96');
    });

    const allHeaders = document.querySelectorAll('.accordion-header');
    allHeaders.forEach((item) => {
      const span = item.querySelector('span');
      if (span) span.textContent = '+';
    });

    // Then open the clicked one if it wasn't already open
    if (!isActive) {
      content.classList.add('!max-h-96');
      const span = header.querySelector('span');
      if (span) span.textContent = '−';
    }
  }
}
